import client from "../client";

export const onSubmitAiCamererieData = async ({ payload }) => {
  return await client.post("/ai/cameriere", payload);
};
